<template>
  <div class="card">
    <h2>Gestione Versioni e Documenti</h2>
    <Loader v-if="loading"/>
    <Accordion :activeIndex="0">
      <AccordionTab header="Aggiorna Versione Documento Esistente">
        <div class="p-fluid grid">
          
          <div class="field col-12 md:col-6">
            <label for="doc_type">Seleziona Tipo Documento</label>
            <Dropdown 
              id="doc_type" 
              v-model="selectedDocumentType.data" 
              :options="documentTypes" 
              optionLabel="name" 
              placeholder="Scegli il documento da aggiornare" 
              @change="handleDocumentTypeChange"
            />
          </div>

          <!-- <div class="field col-12 md:col-6" v-if="selectedDocumentType">
            <label>Sorgente predefinita per questo tipo</label>
            <InputText :value="selectedDocumentType.origine" disabled class="font-bold text-primary" />
          </div> -->
          <div class="field col-12 md:col-6" v-if="verificaRefOggettoEChiave(selectedDocumentType.data, 'id') && selectedDocumentType.data.versione">
            <label>Ultima versione</label>
            <InputText :value="selectedDocumentType.data.versione" disabled class="font-bold text-primary" />
          </div>
          <div class="field col-12" v-if="verificaRefOggettoEChiave(selectedDocumentType.data, 'id')">
            <label>Data inizio nuova versione</label>
            <Calendar id="calendar-24h" v-model="data_inizio" showTime hourFormat="24" dateFormat="dd/mm/yy" :minDate="min_data_inizio"/>
          </div>

          <div class="field col-12" v-if="verificaRefOggettoEChiave(selectedDocumentType.data, 'id')">
            <label for="descrizione">Descrizione Aggiornamento (Cosa è cambiato?)</label>
            <Textarea id="descrizione" v-model="updateForm.descrizione" rows="3" autoResize placeholder="Es. Aggiornato articolo 4 sulle scadenze..." />
          </div>
          <div class="field col-12" v-if="verificaRefOggettoEChiave(selectedDocumentType.data, 'id') && selectedDocumentType.data.versione">
            <label class="font-bold block mb-2">Importanza dell'aggiornamento</label>
            
            <div v-for="opzione in opzioniImportanza" :key="opzione.key" class="mb-2 flex align-items-center">
              <RadioButton 
              v-model="updateForm.importanza" 
              :inputId="opzione.key" 
              name="importanzaAggiornamento" 
              :value="opzione.value" 
              />
              <label :for="opzione.key" class="ml-2 cursor-pointer">
                {{ opzione.label }}
              </label>
            </div>
          </div>

          <div class="flex flex-wrap col-12 justify-content-center" v-if="verificaRefOggettoEChiave(selectedDocumentType.data, 'id')">
            
            <!-- <div v-if="selectedDocumentType.origine === 'PUBLIC' || selectedDocumentType.origine === 'FTP'"> -->
              <FileUpload style="width: 250px"
                mode="basic" 
                accept="application/pdf" 
                :maxFileSize="10000000" 
                @select="onFileSelect" 
                chooseLabel="Carica il nuovo file PDF"
                class="m-2"
              />
            <!-- </div> -->

            <!-- <div v-if="selectedDocumentType.origine === 'BLADE'">
              <label for="nome_blade">Percorso Vista Blade nel codice</label>
              <InputText id="nome_blade" v-model="updateForm.nome_vista_blade" placeholder="Es. pdf.contratti.cte_v2" />
              <small class="text-secondary">Assicurati che il file esista in resources/views/</small>
            </div> -->
            <Button label="Invia Aggiornamento" style="width: 250px" icon="pi pi-upload" @click="submitUpdate" :disabled="isDisabledSendUpdate" :loading="loading" class="m-2"/>
          </div>
          <!-- <div class="col-12 flex justify-content-center mt-3" v-if="selectedDocumentType">
          </div> -->
        </div>
      </AccordionTab>

      <!-- <AccordionTab header="Censisci Nuovo Tipo Documento">
        <div class="p-fluid grid">
          
          <div class="field col-12 md:col-6">
            <label for="new_name">Nome Documento (Es. "CONTRATTO LUCE")</label>
            <InputText id="new_name" v-model="newDocForm.name" placeholder="Inserisci il nome esteso" />
          </div>

          <div class="field col-12 md:col-6">
            <label for="new_code">Codice Univoco (Es. "ctl")</label>
            <InputText id="new_code" v-model="newDocForm.code" placeholder="Es. ctl, v, s, ctr" />
          </div>

          <div class="field col-12 md:col-6">
            <label for="new_origine">Tipo Sorgente (Origine File)</label>
            <Dropdown 
              id="new_origine" 
              v-model="newDocForm.origine_file" 
              :options="origineOptions" 
              placeholder="Seleziona come verrà gestito questo file" 
            />
          </div>

          <div class="field col-12 mt-3">
            <Button label="Censisci Documento" icon="pi pi-plus" class="p-button-success" @click="submitNewDocument" :loading="loading" />
          </div>

        </div>
      </AccordionTab> -->
      <AccordionTab header="Storico Versioni">
        <DataTable :value="storicoVersioni.data" showGridlines scrollable class="file-table">
          <Column v-for="col of storicoVersioni.columns" :key="col.filed" :field="col.field" :header="col.label">
            <template #body="{data}">
              <template v-if="col.type === 'button'">
                <template v-if="data.can_download">
                  <Button 
                  icon="pi pi-download" 
                  v-tooltip="'Scarica'" 
                  class="p-button-sm p-button-text"
                  @click="downloadFileVersione(data.id)" 
                  />
                </template>
              </template>
              
              <template v-else-if="col.type === 'datetime'">
                {{ formatDate(data[col.field]) }}
              </template>
              
              <template v-else>
                {{ data[col.field] }}
              </template>
            </template>
          </Column>
          <template #empty> Non esistono versioni precedenti </template>
        </DataTable>
      </AccordionTab>
    </Accordion>

  </div>
</template>

<script>
  import { ref, computed, getCurrentInstance, onMounted, isRef } from 'vue';
  import Service from '@/services/ask-caricamento-file/caricamento-file'
  import Loader from "@/components/Loader.vue";
  import { useToast } from "primevue/usetoast";
  import moment from 'moment';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Calendar from "primevue/calendar";

  export default {
    name: 'GestioneDocumenti',
    components: {
      Loader,
      DataTable,
      Column,
      Calendar
    },
    setup(){
      const loading = ref(false)
      const toast = useToast();
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      const service = new Service(self.$eventBus)
      const data_inizio = ref(null)
      const min_data_inizio = ref(null)

      const documentTypes = ref([])
      const selectedDocumentType = ref({
        data: null,
        versione: null,
        reset(){
          selectedDocumentType.value.versione = null
          selectedDocumentType.value.data = null
        }
      })
      const origineOptions = ref(['PUBLIC', 'FTP', 'BLADE'])
      
      const storicoVersioni = ref({
        data: [],
        columns: []
      })
      // Form aggiornamento versione
      const updateForm = ref({
        descrizione: '',
        pdf: null,
        nome_vista_blade: '',
        importanza: 'patch',
        reset(){
          updateForm.value.descrizione = ''
          updateForm.value.pdf = null
          updateForm.value.nome_vista_blade = ''
          updateForm.value.importanza = 'patch'
        }
      })
      const opzioniImportanza = ref([
        { label: 'Major (Cambiamenti importanti / breaking)', value: 'major', key: 'imp-major' },
        { label: 'Minor (Nuove funzionalità retrocompatibili)', value: 'minor', key: 'imp-minor' },
        { label: 'Patch (Correzione bug / manutenzione)', value: 'patch', key: 'imp-patch' }
      ]);
      
      const newDocForm = ref({
        name: '',
        code: '',
        origine_file: null
      })

      onMounted(() => {
        mount()
      })
      const mount = () => {
        data_inizio.value = new Date()
        loading.value = true;
        Promise.all([
          loadDocumentTypes(),getStoricoVersioni()
        ])
        .finally(()=>{
          loading.value = false
        })
      } 
      const getStoricoVersioni = async () => {
        try {
          const response = await service.getStoricoVersioni();
          storicoVersioni.value.data = response.data || [];
          storicoVersioni.value.columns = response.columns || [];
        } catch (error) {
          toast.add({severity: 'warn', detail: "Errore nel caricamento dello storico versioni"});
        }
      }
      const loadDocumentTypes = async () => {
        try {
          documentTypes.value = await service.getAllTypesDocumenti();          
        } catch (error) {
          toast.add({severity: 'warn', detail: "Errore nel caricamento dei tipi documento"});
        }
      }
      const isDisabledSendUpdate = computed(() => {
        if(!updateForm.value.descrizione) return true
        // if(selectedDocumentType.value.data.origine === 'PUBLIC' || selectedDocumentType.value.data.origine === 'FTP')
        return !updateForm.value.pdf
  
        // return !updateForm.value.nome_vista_blade 
      })
      const handleDocumentTypeChange = () => {
        min_data_inizio.value = null
        data_inizio.value = new Date()

        if(verificaRefOggettoEChiave(selectedDocumentType.value.data, 'data_inizio_versione') && selectedDocumentType.value.data.data_inizio_versione){
          min_data_inizio.value = new Date(moment(selectedDocumentType.value.data.data_inizio_versione).add(1, 'seconds'))
          data_inizio.value = new Date(moment(selectedDocumentType.value.data.data_inizio_versione).add(1, 'minute'))
        }
        updateForm.value.reset()
      }

      const verificaRefOggettoEChiave = (variabileRef, chiave) => {
        const valore = isRef(variabileRef) ? variabileRef.value : variabileRef;

        return valore !== null && typeof valore === 'object' && !Array.isArray(valore) && chiaveInOggetto(valore, chiave);
      }

      const chiaveInOggetto = (obj, key) => {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
  
      const onFileSelect = (event) => {
        updateForm.value.pdf = event.files[0];
      }

      const formatData = (date) => {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
      }
      const submitUpdate = async () => {
        const origine = selectedDocumentType.value.data.origine;
        
        if (origine !== 'BLADE' && !updateForm.value.pdf) {
          alert("Seleziona un file PDF prima di inviare!");
          return;
        }

        loading.value = true;
        try {
          let fd = new FormData();
          fd.append('cod_type_documento', selectedDocumentType.value.data.id);
          fd.append('last_version', selectedDocumentType.value.data.versione);
          fd.append('origine_file', 'PUBLIC');
          fd.append('descrizione_aggiornamento', updateForm.value.descrizione);
          fd.append(`file[]`, updateForm.value.pdf);
          fd.append(`data_inizio`, formatData(data_inizio.value));
          fd.append(`importanza`, updateForm.value.importanza);

          const response = await service.storeNuovaVersione(fd);
          
          let severity = response.success ? 'success' : 'warn'
          let detail = response.success ? response.message : response.errors
          toast.add({severity: severity, detail: detail})
          if (response.success) {
            selectedDocumentType.value.reset()
            handleDocumentTypeChange();
            getStoricoVersioni();
          }
        } catch (error) {
          alert("Errore: " + (error.response?.data?.message || error.message));
        } finally {
          mount()
        }
      }

      const formatDate = (value) => {
        if (!value) return '-';
        return moment(value).format('DD/MM/YYYY HH:mm');
      }

      const downloadFileVersione = async (id) => {
        loading.value = true;
        
        try {
          await service.downloadFileVersione(id);
        } catch (error) {
          console.error("Errore durante il download del file:", error);
        } finally {
          loading.value = false;
        }
      };

      // CREAZIONE NUOVO TIPO DOCUMENTO
      // const submitNewDocument = async () => {
      //   if (!newDocForm.value.name || !newDocForm.value.code || !newDocForm.value.origine_file) {
      //     alert("Compila tutti i campi obbligatori!");
      //     return;
      //   }

      //   loading.value = true;
      //   try {
      //     // Chiamata al Service passando i dati del nuovo form
      //     const newDoc = await service.createTipoDocumento(newDocForm.value);
          
      //     alert("Nuovo tipo di documento censito con successo!");
          
      //     // Aggiungiamo il nuovo record direttamente nell'array per aggiornare il dropdown
      //     documentTypes.value.push(newDoc);

      //     // Reset del form
      //     newDocForm.value = { name: '', code: '', origine_file: null };
      //   } catch (error) {
      //     alert("Errore durante il censimento: " + error.message);
      //   } finally {
      //     loading.value = false;
      //   }
      // }
      return {
        loading, documentTypes, selectedDocumentType, origineOptions, updateForm, newDocForm, isDisabledSendUpdate, handleDocumentTypeChange, onFileSelect, submitUpdate, 
        // submitNewDocument, 
        data_inizio, storicoVersioni, opzioniImportanza, verificaRefOggettoEChiave, min_data_inizio, formatDate, downloadFileVersione
      }
    }
  }
</script>



<style scoped>

</style>
